<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
            <div class="text-small">The user can add vendors from the existing list of vendors.</div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="user-profile__form">
                <section>
                    <form class="row g-3" [formGroup]="searchVendorForm">
                        <!-- <div class="col-md-4">
                            <label for="line_item_number" class="form-label text-small">Select the line item(s) to assign vendors to</label>
                            <select formControlName="line_item_number" class="form-control form-control-sm" [error]="searchVendorForm.get('line_item_number')"
                             [(ngModel)] = "lineitemNumber">
                                <option [ngValue]="null" selected disabled>Select Lineitem</option>
                                <option *ngFor="let lineItem of lineitem_list" [value]="lineItem">{{ lineItem }}</option>
                            </select>
                            <form-feedback [formGroup]="searchVendorForm" field="line_item_number"></form-feedback>
                        </div> -->
                        <div class="col-md-4">
                            <label for="vendor_code" class="form-label text-small">search vendor</label>
                            <input type="text" class="form-control form-control" id="vendor_code" formControlName="vendor_code" [error]="searchVendorForm.get('vendor_code')">
                            <form-feedback [formGroup]="searchVendorForm" field="vendor_code"></form-feedback>
                        </div>
                        <div class="col-md-4">
                            <div class="m-4">
                                <button type="button" class="btn btn-primary m-2 text-white" (click)="fetchVendordata()" [disabled]="!searchVendorForm.valid">Search</button>
                            </div>
                        </div>
                    </form>
            </section>
            </div>
            <div class="card mt-1" *ngIf="vendorResults?.length">
                <div class="card-body p-4">
                    <h5>Vendor results</h5>
                    <div><span class="text-small">Select a vendor from below to be added</span>
                    </div>
                    <div class="d-flex mb-4 mt-1 justify-content-end">
                        <button type="button" class="btn btn-outline-primary me-2" (click)="validateVendor()">
                            Add vendor to table
                        </button>
                    </div>
                    <ng-container>
                        <app-ag-grid-wrapper #grid [gridConfig]='gridOptions' [rowData]="vendorResults"
                            [columnDefs]="columnDefs" [frameworkComponents]='frameworkComponents' [context]='context' (gridReady)="onGridReady()">
                        </app-ag-grid-wrapper>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</section>